import { getDisplayChannelsIds } from 'gcs-common/slices/channelList/channelListSelectors/getDisplayChannelsIds';
import React from 'react';
import { useSelector } from 'react-redux';
import { Virtuoso } from 'react-virtuoso';
import ChannelListItemWithDateTag from '../../ChannelListItemWithDateTag/ChannelListItemWithDateTag';
import styles from './styles.module.scss';

// Note: To style the list a forwardRef must be passed
const List = React.forwardRef((props, ref) => <div {...props} ref={ref} className={styles.listWrapper} />);

const Footer = () => <div className={styles.listFooter} />;
const Item = (props) => <div {...props} className={styles.itemWrapper} />;

const AgentChannelList = () => {
  const channelIds = useSelector(getDisplayChannelsIds);
  return (
    <div className={styles.channelList}>
      <Virtuoso
        data={channelIds}
        itemContent={(index) => <ChannelListItemWithDateTag channelId={channelIds[index]} />}
        components={{
          Footer,
          List,
          Item,
        }}
      />
    </div>
  );
};

export default AgentChannelList;
